import template from './flight-segment-alternatives.html';

const DIRECTIVE_NAME = AtcFlightSegmentAlternatives.DIRECTIVE_NAME = 'ktAtcFlightSegmentAlternatives';
export default function AtcFlightSegmentAlternatives() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: AtcFlightSegmentAlternativesController,
        controllerAs: '$ctrl',
        scope: {
            segment: `=${DIRECTIVE_NAME}`,
            recommendation: `=${DIRECTIVE_NAME}Recommendation`,
            selectedFlights: `=${DIRECTIVE_NAME}SelectedFlights`,
            onSelectGroup: `&${DIRECTIVE_NAME}OnSelectGroup`,
        },
        link: function($scope, $elem, $attrs, atcFlightSegmentAlternativesCtrl) {
            atcFlightSegmentAlternativesCtrl.$onInit();
        },
    };
}

export function AtcFlightSegmentAlternativesController(
    atcFlightSegmentService,
    atcFlightSegmentAlternativesService,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        selectGroup,
        doesOverlapSiblingSegments,
    });

    function $onInit() {
        initGroups();
    }

    function initGroups() {
        const group = atcFlightSegmentService.getSelectedGroup(vm.selectedFlights, vm.segment);
        vm.groups = vm.segment.FlightGroups.filter(({FlightGroupId}) => FlightGroupId !== group.FlightGroupId);
    }

    function selectGroup(group) {
        if (doesOverlapSiblingSegments(group)) {
            return;
        }
        atcFlightSegmentService.selectGroup(vm.selectedFlights, vm.segment, group);
        vm.onSelectGroup();
        initGroups();
    }

    function doesOverlapSiblingSegments(group) {
        return atcFlightSegmentAlternativesService.doesOverlapSiblingSegments(vm.recommendation, vm.segment, group, vm.selectedFlights);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/atc-flights-view/flight-recommendation/flight-segment/flight-segment-alternatives/flight-segment-alternatives-component.js